import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/warehouse-kinds/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const warehouseKinds = {
  getAll: apiPathFunc(pathBase),
} as const;
